import { render, staticRenderFns } from "./RsaDynamicBodyAreaComponents.vue?vue&type=template&id=39e60058&scoped=true"
import script from "./RsaDynamicBodyAreaComponents.vue?vue&type=script&lang=js"
export * from "./RsaDynamicBodyAreaComponents.vue?vue&type=script&lang=js"
import style0 from "./RsaDynamicBodyAreaComponents.vue?vue&type=style&index=0&id=39e60058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e60058",
  null
  
)

export default component.exports